'use client';

import { ArrowRight } from 'lucide-react';

import { Button } from '@repo/ui/button';

import { useContactDialog } from './contact-dialog-context';

export function HeroSectionCTA() {
  const { openContactDialog } = useContactDialog();

  return (
    <Button size="lg" className="group" onClick={openContactDialog}>
      Start Your Project
      <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
    </Button>
  );
}
